import { createSlice } from '@reduxjs/toolkit';

const initialState={
    stagedDevice:null
}
export const stagedDeviceSlice = createSlice({
  name: 'stagedDevice',
  initialState,
  reducers: {

    
      
      setStagedDevice: (state, action) => {
        state.stagedDevice = action.payload;
        
      },
      
    
    setLogoutStagedDevice: (state,action)=>{
      state.stagedDevice=null
    }
  },
});

export const {  setStagedDevice,setLogoutStagedDevice} = stagedDeviceSlice.actions;

export default stagedDeviceSlice.reducer;
